import {
	AlertDialog,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogAction,
	AlertDialogCancel,
} from "@/components/primitives";
import { buttonVariants } from "@/components/ui/button";

interface ArchiveDialogsProps {
	showArchiveDialog: boolean;
	showUnarchiveDialog: boolean;
	onArchiveConfirm: () => void;
	onArchiveCancel: () => void;
	onUnarchiveConfirm: () => void;
	onUnarchiveCancel: () => void;
}

export function ArchiveDialogs({
	showArchiveDialog,
	showUnarchiveDialog,
	onArchiveConfirm,
	onArchiveCancel,
	onUnarchiveConfirm,
	onUnarchiveCancel,
}: ArchiveDialogsProps) {
	return (
		<>
			<AlertDialog open={showArchiveDialog} onOpenChange={onArchiveCancel}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>Archive Reflection</AlertDialogTitle>
						<AlertDialogDescription>
							Are you sure you want to archive this reflection? Archived
							reflections will not appear in your daily check-ins and will be
							moved to your archived reflections list. You can unarchive it
							later if needed.
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel onClick={onArchiveCancel}>
							Cancel
						</AlertDialogCancel>
						<AlertDialogAction
							onClick={onArchiveConfirm}
							className={buttonVariants({ variant: "default" })}
						>
							Archive Reflection
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>

			<AlertDialog open={showUnarchiveDialog} onOpenChange={onUnarchiveCancel}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>Unarchive Reflection</AlertDialogTitle>
						<AlertDialogDescription>
							Are you sure you want to unarchive this reflection? It will become
							active again and appear in your daily check-ins and regular
							reflection lists.
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel onClick={onUnarchiveCancel}>
							Cancel
						</AlertDialogCancel>
						<AlertDialogAction
							onClick={onUnarchiveConfirm}
							className={buttonVariants({ variant: "default" })}
						>
							Unarchive Reflection
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	);
}
